import { useState } from 'react';
import { Popper, PopperProps } from '@material-ui/core';

import poweredBySectionStyles from 'components/PoweredBySection/PoweredBySection.module.scss';

const BOUNDARY_PADDING = 5;

const FOOTER_GAP = 8;

interface IFooterAwarePopper extends PopperProps {}

const getBottomBoundaryPadding = () => {
  const footerElement = document.querySelector(
    `.${poweredBySectionStyles.container}`
  );

  if (!footerElement) return BOUNDARY_PADDING;

  return footerElement.getBoundingClientRect().height + FOOTER_GAP;
};

// FOOTER AWARE
const FooterAwarePopper = (props: IFooterAwarePopper) => {
  const [boundaryPadding] = useState(() => ({
    top: BOUNDARY_PADDING,
    left: BOUNDARY_PADDING,
    right: BOUNDARY_PADDING,
    bottom: getBottomBoundaryPadding(),
  }));

  return (
    <Popper
      {...props}
      placement="bottom"
      modifiers={{
        preventOverflow: {
          enabled: true,
          boundariesElement: 'viewport',
          padding: boundaryPadding,
        },
        flip: {
          enabled: true,
          boundariesElement: 'viewport',
          padding: boundaryPadding,
        },
      }}
    />
  );
};

export default FooterAwarePopper;
